<ion-card class="app-background ion-padding">
  <form [formGroup]="professionalDetailsForm" (ngSubmit)="submitDetails()">
    <ion-grid class="ion-padding">
      <ion-row class="ion-text-center">
        <ion-col size="12">
          <ion-label class="panel-header-text" color="dark">
            {{ 'register_step2Title' | translate }}
          </ion-label>
        </ion-col>
      </ion-row>

      <ion-row class="ion-margin-top">
        <ion-col size="12">
          <ion-label class="panel-label-text"
            >{{ 'register_companyName' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            formControlName="companyname"
            placeholder="Enter company name"
            class="ion-margin-top"
          >
          </ion-input>
        </ion-col>
      </ion-row>

      <ion-row class="ion-margin-top">
        <ion-col size="12">
          <ion-label class="panel-label-text"
            >{{ 'register_vatNo' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            formControlName="vatno"
            placeholder="BE0123456789"
            class="ion-margin-top"
          >
          </ion-input>
        </ion-col>
      </ion-row>

      <ion-row class="ion-margin-top">
        <ion-col size="12" size-lg="10" size-xl="8">
          <ion-item lines="none" class="ion-no-padding transparent-item">
            <ion-checkbox
              formControlName="terms"
              label-placement="end"
              justify="start"
            >
              <span [innerHTML]="'register_terms' | translate"></span>
            </ion-checkbox>
          </ion-item>
          <div
            class="ion-margin-top termsInfo"
            [innerHTML]="'register_termsInfo' | translate"
          ></div>
        </ion-col>
      </ion-row>

      <ion-row class="ion-margin-top ion-align-items-center">
        <ion-col size="6">
          <ion-button fill="clear" (click)="goBack()" aria-label="Go Back">
            <ion-icon
              name="arrow-back-outline"
              slot="icon-only"
              class="icon-x1"
            ></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button
            type="submit"
            class="ion-float-right"
            color="primary"
            [disabled]="professionalDetailsForm.invalid"
          >
            <small>{{ 'register_next' | translate }}</small>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-card>
